import { render } from "./inventario.vue?vue&type=template&id=1ab9b25a"
import script from "./inventario.vue?vue&type=script&lang=js"
export * from "./inventario.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__